import { Tooltip } from "@radix-ui/themes";
import { memo, FC } from "react";

const BaseTooltipWrapper: FC<{
  tooltipContent: JSX.Element;
  overlayTrigger: JSX.Element;
}> = ({ tooltipContent, overlayTrigger }): JSX.Element => {
  return <Tooltip content={tooltipContent}>{overlayTrigger}</Tooltip>;
};

export default memo(BaseTooltipWrapper);
